<template>
  <LoadingSpinner v-if="loading" />
  <form v-else @submit.prevent="$emit('submit', topic)" class="form" method="post">
    <template v-if="companyUser.company_type == 'branch'">
      <div class="row row-gutter-20">
        <div class="col-8">
          <div class="form-wrap select-wrap">
            <label for="type">{{ $t('meta.type') }}</label>
            <select v-model="topic.type" class="select-wrap">
              <option value="fill_level">{{ $t('containers.fillLevel') }}</option>
            </select>
          </div>
        </div>
        <div class="col-8">
          <div class="form-wrap select-wrap">
            <label for="matcher">{{ $t('notifications.types.fillLevel.matcher') }}</label>
            <select v-model="topic.matcher" class="select-wrap">
              <option value="equals">
                {{ $t('notifications.types.fillLevel.matchers.equal') }}
              </option>
              <option value="greater_than">
                {{ $t('notifications.types.fillLevel.matchers.greaterThan') }}
              </option>
              <option value="less_than">
                {{ $t('notifications.types.fillLevel.matchers.lessThan') }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-8">
          <div class="form-wrap">
            <label for="value">{{ $t('containers.value') }}</label>
            <input v-model="topic.value" class="form-input" type="number" name="value" id="value" min="0" max="150" />
          </div>
        </div>
      </div>

      <div class="form-wrap select-wrap">
        <label for="type">{{ $t('notifications.types.fillLevel.interval') }}</label>
        <select v-model="topic.interval" class="select-wrap">
          <option value="instant">
            {{ $t('notifications.types.fillLevel.intervals.instant') }}
          </option>
          <option value="daily">
            {{ $t('notifications.types.fillLevel.intervals.daily') }}
          </option>
          <option value="weekly">
            {{ $t('notifications.types.fillLevel.intervals.weekly') }}
          </option>
        </select>
      </div>

      <div class="form-wrap select-wrap">
        <label for="project">{{ $t('meta.project') }}</label>
        <select v-model="topic.project_uuid" class="form-input" id="project" name="project" required>
          <option v-for="project in projects" :key="project.uuid" v-bind:value="project.uuid">
            {{ project.name }}
          </option>
        </select>
      </div>
    </template>

    <template v-if="companyUser.company_type == 'industry'">
      <div class="row row-gutter-20">
        <div class="col-8">
          <div class="form-wrap select-wrap">
            <label for="type">{{ $t('meta.type') }}</label>
            <select v-model="topic.type" class="select-wrap">
              <option value="order">{{ $t('meta.order') }}</option>
            </select>
          </div>
        </div>
        <div class="col-8">
          <div class="form-wrap select-wrap">
            <label for="matcher">{{ $t('notifications.types.order.orderType') }}</label>
            <select v-model="topic.order_type" class="select-wrap">
              <option value="emptying_order">
                {{ $t('notifications.types.order.orderTypes.emptying_order') }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-8">
          <div class="form-wrap select-wrap">
            <label for="value">{{ $t('containers.value') }}</label>
            <select v-model="topic.action" class="select-wrap">
              <option value="created">
                {{ $t('notifications.types.order.actions.created') }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </template>

    <div class="form-wrap">
      <label for="type">{{ $t('notifications.channels') }}</label>

      <div v-for="channel in channels" :key="channel.uuid">
        <label class="checkbox-wrap" style="margin-top: 0.5rem">
          <input type="checkbox" :value="channel.uuid" v-model="topic.channel_uuids" />
          {{ channel.email }}
        </label>
      </div>
    </div>

    <p style="margin: 0; margin-top: 1rem">
      <input type="submit" :value="submitText" class="button button-green button-round" />
    </p>
  </form>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'

import notificationChannelsApi from '@/api/notificationChannels'
import projectsApi from '@/api/projects'

export default {
  inject: ['companyUser'],
  components: { LoadingSpinner },
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      loading: true,
      topic: { ...this.value },
      projects: [],
      channels: [],
    }
  },
  watch: {
    value: {
      handler(topic) {
        this.topic = { ...topic }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    channelOptions: function () {
      return this.channels.map(function (channel) {
        return { label: channel.email, value: channel.uuid }
      })
    },
    submitText() {
      if (this.topic.uuid) {
        return `${this.$t('notifications.updateTopic')} ›`
      } else {
        return `${this.$t('notifications.createTopic')} ›`
      }
    },
  },
  async mounted() {
    this.projects = await projectsApi.getAll(this.companyUser.company_uuid)
    this.channels = await notificationChannelsApi.getAll(this.companyUser.company_uuid)
    this.loading = false
  },
}
</script>

<style lang="scss">
@import '@/components/Form/Checkbox/Checkbox.scss';
</style>
